import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

const fetchPlanBookData = async (planId: string, workcenterId: string) => {
  const data = await request({
    url: `plan/${planId}/workcentres/${workcenterId}/planning_book`,
  })
  return data
}
export const usePlanBookData = (
  planId: string,
  workcenterId: string,
  enabled = true
) => {
  return useQuery(
    ['plan-book', planId, workcenterId],
    () => fetchPlanBookData(planId, workcenterId),
    {
      select: ({ data }) => data,
      refetchOnWindowFocus: false,
      enabled: enabled,
    }
  )
}
